import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createCusFeedback = async (values, callback) => {
    const res = await axios.post(`/customerfeedback/createcusfeedback`, values);
    callback(res.data.response)
}
export const updateCusFeedback = async (id, values, callback) => {
    const res = await axios.put(`/customerfeedback/updatecusfeedback/${id}`, values);
    callback(res.data.response);
}

export const deleteCusFeedback = async (id, values, callback) => {
    const res = await axios.put(`/customerfeedback/deletecusfeedback/${id}`, { updatedBy: values });
    callback(res.data.response);
}

export const getAllCusFeedback = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/customerfeedback/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`)
    callback(res.data.response)
}

export const getAllCusFeedbackById = async (id, callback) => {
    const res = await axios.get(`/customerfeedback/getalldetailbyid/${id}`);
    callback(res.data.response)
}

export const getCusFeedbackById = async (id, callback) => {
    const res = await axios.get(`/customerfeedback/${id}`);
    callback(res.data.response)
}

export const getCusFeedbackByParentId = async (id, callback) => {
    const res = await axios.get(`/customerfeedback/getbyparentid/${id}`);
    callback(res.data.response)
}

export const CustomerFeedbackAPI = () => {
    const [cusFeedbacks, setCusFeedbacks] = useState([]);
    const [cusFeedbackDetail, setCusFeedbackDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [cusFeedbackId, setCusFeedbackId] = useState(0);

    useEffect(() => {
        getAllCusFeedback(rowPerPage, pageNumber, search, res => {
            setCusFeedbacks(res.data);
        });

        getCusFeedbackById(cusFeedbackId, res => {
            setCusFeedbackDetail(res.data)
        });
    }, [callback, rowPerPage, search, pageNumber, cusFeedbackId])

    return {
        cusFeedbacks: [cusFeedbacks, setCusFeedbacks],
        cusFeedbackDetail: [cusFeedbackDetail, setCusFeedbackDetail],
        cusFeedbackId: [cusFeedbackId, setCusFeedbackId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}